import Events from './events';

export default Events;



// WEBPACK FOOTER //
// ./src/components/cards/events/index.js